<div class="cell cell--top">
    {{params?.value?.topLabel}}
</div>
<div class="cell cell--bottom">
    {{params?.value?.bottomLabel}}
</div>